var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1275,
    cy: 10.0904,
    r: 3.93412,
    fill: "#11643C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88673 19.495C7.88568 19.2185 7.94753 18.9453 8.06761 18.6961C8.44444 17.9425 9.50711 17.543 10.3889 17.3622C11.0248 17.2265 11.6696 17.1358 12.3183 17.0908C13.5193 16.9853 14.7273 16.9853 15.9283 17.0908C16.577 17.1363 17.2217 17.227 17.8577 17.3622C18.7395 17.543 19.8021 17.9048 20.179 18.6961C20.4205 19.204 20.4205 19.7936 20.179 20.3014C19.8021 21.0928 18.7395 21.4546 17.8577 21.6279C17.2225 21.7692 16.5775 21.8624 15.9283 21.9067C14.9508 21.9896 13.9687 22.0047 12.989 21.952C12.7629 21.952 12.5444 21.952 12.3183 21.9067C11.6715 21.863 11.029 21.7698 10.3964 21.6279C9.50711 21.4546 8.45198 21.0928 8.06761 20.3014C7.94814 20.0494 7.88635 19.7739 7.88673 19.495Z",
    fill: "#11643C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.5e4f1bc684019fad90e8f177a5778c8d.svg";
export { ForwardRef as ReactComponent };